import { combineReducers } from 'redux';

import * as types from 'modules/cameras/actionTypes';
import { DASHBOARD_SOURCE } from 'modules/cameras/constants';
import type { Action } from 'modules/global/generic.types';
import loadingArraySlice from 'modules/global/reducers/loadingArraySlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import type { MayBe } from 'modules/global/typing/common/common';

import filters from './filters';

const dashboardSourceMatcher = ({ meta }: Action) => meta?.source === DASHBOARD_SOURCE;

// The request actions carry the camera id at the payload root; the success/failure paths are
// covered by loadingArraySlice itself (bare uuid, `payload.id`, `meta.entityId`).
const selectCameraLoadingId = (payload: MayBe<{ cameraId?: string }>): MayBe<string> => payload?.cameraId;

const LOADING_SLICE_CONFIG = {
  global: { matcher: dashboardSourceMatcher, selectId: selectCameraLoadingId },
};

export default combineReducers({
  filters,
  patching: loadingArraySlice(types.PATCH_STATUS_REQUEST, LOADING_SLICE_CONFIG),
  deleting: loadingArraySlice(types.DELETE_REQUEST, LOADING_SLICE_CONFIG),
  data: createSearchReducers(types.FETCH_CAMERAS, {
    global: { matcher: dashboardSourceMatcher, paginationSlice: true },
  }),
});
